// extracted by mini-css-extract-plugin
export default {"portfolioGridContainer":"Portfolio_portfolioGridContainer__c5raT","portfolioHeader":"Portfolio_portfolioHeader__sS8Wv"};